import "../../css/guest-selector.css"
import React, {Dispatch, FC, SetStateAction, useEffect, useState} from "react";
import Input from "../../../../components/form/Input";
import {Guest, RsvpRequest} from "../../../../types/Guests";
import {toast} from "react-toastify";

type RsvpStatus = "DECLINED" | "INVITED" | "RSVP";

interface MyComponentProps {
    rsvpMap:Map<number, RsvpRequest>
    guests: Guest[]
    setRsvpCompleted: Dispatch<SetStateAction<boolean>>
}

const GuestSelector:FC<MyComponentProps> = ({ rsvpMap, guests, setRsvpCompleted }) => {
    const [declinedGuests, setDeclinedGuests] = useState<number[]>([]);
    const [acceptedGuests, setAcceptedGuests] = useState<number[]>([]);

    // Filter out plus ones - only show main guests
    const mainGuests = guests.filter(g => !g.plusOne && !g.plusOneOwner);

    useEffect(() => {
        setAcceptedGuests(mainGuests.filter(g => g.status === "RSVP").map(g => g.id));
        setDeclinedGuests(mainGuests.filter(g => g.status === "DECLINED").map(g => g.id));

        // Pre-populate rsvpMap for guests that already have a status from the server
        mainGuests.forEach(g => {
            if (!rsvpMap.has(g.id) && (g.status === "RSVP" || g.status === "DECLINED")) {
                rsvpMap.set(g.id, {
                    status: g.status as RsvpStatus,
                    guestId: g.id,
                    optionIds: []
                });
            }
        });
    }, [guests]);

    // @ts-ignore
    const handleSubmit = async (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();

        if (acceptedGuests.length + declinedGuests.length !== mainGuests.length) {
            toast.error("Please accept or decline invitation for each guest")
        }

        setRsvpCompleted(true);
    };

    const getBtnClassForRsvpStatus = (id:number | undefined, status:RsvpStatus) => {
        if (id) {
            if ((status === "RSVP" && acceptedGuests.includes(id))
                || (status === "DECLINED" && declinedGuests.includes(id))) {
                return "rsvp__btn-selected";
            } else {
                return "rsvp__btn";
            }
        }
    }

    // @ts-ignore
    const handleGuestChoice = (event: MouseEvent<HTMLButtonElement>, id:number | undefined, status:RsvpStatus) => {
        event.preventDefault();

        if (id) {

            //Must do in this way to cause re-render on button classes
            if (status === "RSVP") {
                let accGuests = acceptedGuests;
                let decGuests = declinedGuests;
                accGuests.push(id);
                decGuests = decGuests.filter(g => g !== id);
                setAcceptedGuests(accGuests);
                setDeclinedGuests(decGuests);
            } else {
                let accGuests = acceptedGuests;
                let decGuests = declinedGuests;
                decGuests.push(id);
                accGuests = accGuests.filter(g => g !== id);
                setAcceptedGuests(accGuests);
                setDeclinedGuests(decGuests);
            }

            rsvpMap.set(id, {
                status: status,
                guestId: id,
                optionIds: []
            });
        }
    }

    return (
        <div className="rsvp__guestRsvp">
            <form className="form__input" onSubmit={handleSubmit}>
                <div className="rsvp__guestRsvp">
                    <h2>Will you be attending our wedding?</h2>
                    {
                        mainGuests.map((guest) => {
                            return (
                                <div className="rsvp__guest-rsvpRow">
                                    <h2>{guest.firstName} {guest.lastName}</h2>
                                    <div className="rsvp__guest-rsvpBtns">
                                        <Input
                                            type="submit"
                                            name="guestChoice"
                                            value="Accept"
                                            className={getBtnClassForRsvpStatus(guest.id, "RSVP")}
                                            onClick={(e) => {
                                                handleGuestChoice(e, guest.id, "RSVP")
                                            }}
                                        />
                                        <Input
                                            type="submit"
                                            name="guestChoice"
                                            value="Decline"
                                            className={getBtnClassForRsvpStatus(guest.id, "DECLINED")}
                                            onClick={(e) => {
                                                handleGuestChoice(e, guest.id, "DECLINED")
                                            }}
                                        />
                                    </div>
                                </div>
                            );
                        })
                    }
                    <Input
                        type={"submit"}
                        name={"submitRsvpStatus"}
                        value={"Next"}
                        onClick={handleSubmit}
                    />
                </div>
            </form>
        </div>
    );
};

export default GuestSelector;
